import {
  BOOST_CATEGORY,
  BOOST_UI_STATUS,
  BoostDetails,
  TRIP_STATUS,
  TRIP_TYPE,
  Trip,
} from '../../../types/src';

export const tripMock: Trip = {
  state: TRIP_STATUS.PAID,
  sortKey: '123',
  startDate: '2023-01-01',
  endDate: '2023-01-02',
  destinations: [
    { longName: 'London', countryCode: 'GB', countryId: 'GBR', imageLinks: {}, emcRiskCode: 201 },
  ],
  secondaryTravellers: [
    {
      dob: '2011-12-12',
      firstName: 'Mahan',
      lastName: 'Na',
      isDependant: true,
      isSelected: false,
      isResident: true,
    },
  ],
  primaryTraveller: {
    dob: '1990-01-01',
    firstName: 'John',
    lastName: 'Doe',
    email: 'John.Doe@gmail.com',
    isResident: true,
    address: '27 Porter Street, Ryde, VIC, 3181',
  },
  primaryTravellerId: '123',
  boosts: [],
  price: 124,
  pdsLink: '',
  presignedCoiLink: '',
  policyStatus: 'NORMAL',
  isTripStarted: false,
  hasAddedBoosts: false,
  pendingUpdates: null,
  productId: '',
  policy: {
    effectiveDate: new Date(),
    expireDate: new Date(),
    orderDate: new Date(),
    policyNumber: '',
  },
  metaData: {
    excessAmount: 250,
  },
};

export const tripMockForUS: Trip = {
  primaryTraveller: {
    dob: '1990-01-01',
    firstName: 'John',
    lastName: 'Doe',
    isResident: true,
  },
  state: TRIP_STATUS.PAID,
  productId: '',
  primaryTravellerId: '123',
  hasAddedBoosts: false,

  boosts: [
    {
      description: 'The Essentials Plan.',
      name: 'The Essentials Plan',
      duration: 2,
      userId: '7ae4313e-c812-4de3-b9d0-5097ee69daa4',
      code: 'USTEP',
      template: {
        pdsLink: {
          title: 'Read our Policy',
          value: 'https://d3taykp79ux94z.cloudfront.net/public/us/pds/al/2022-05-27/policy.pdf',
        },
        inclusions: [
          {
            subTitle: 'If you have to cancel your trip when you are already traveling',
            title: 'Trip Interruption',
            iconPath: '/public/us/boost-images/USOEP-Plane.svg',
          },
          {
            subTitle:
              'If your luggage is lost, stolen or damaged. You can upgrade this if you want',
            title: 'Your Luggage',
            iconPath: '/public/us/boost-images/USOEP-Luggage.svg',
          },
          {
            subTitle: 'If you have a medical emergency when traveling',
            title: 'Emergency<br/>Medical Expense',
            iconPath: '/public/us/boost-images/USOEP-Medical.svg',
          },
          {
            subTitle: 'If you need Emergency Dental work when you’re traveling',
            title: 'Emergency<br/>Dental Expense',
            iconPath: '/public/us/boost-images/USOEP-Dental.svg',
          },
        ],
        additionalInformation: {
          heading: 'Additional Information',
          items: [],
        },
        sortKey: '2023-03-29',
        coverDetails: {
          covered: {
            items: [
              {
                type: 'bold',
                value: 'Snapshot',
              },
              {
                type: 'text',
                value: 'A quick summary of what this plan provides coverage for:',
              },
              {
                type: 'bullet',
                value: [
                  'Trip Interruption Coverage up to 150% of your pre-paid and non-refundable trip cost if a portion of a trip is missed, or if you must return home early due to unforeseen circumstances, including illness, injury, or death.',
                  'Single Occupancy coverage up to 150% of trip cost if your traveling companion interrupts their trip for a covered reason and you choose to still go but have additional costs related to single occupancy.',
                  'Reimbursement for direct loss, theft, damage or destruction of baggage, personal eﬀects or passports.',
                  'The cost of reasonable additional clothing and personal articles if your luggage is delayed for more than 12 hours.',
                  'The costs to expedite the return of delayed or misdirected baggage.',
                  'Coverage up to the policy limits below for the costs to treat a medical emergency, including COVID-19, during a trip.',
                  'Emergency Medical Transportation & Repatriation to the nearest adequate medical facility or home in the event of a medical emergency during the covered trip.',
                ],
              },
              {
                type: 'bold',
                value: 'Benefits and Coverage Limits',
              },
              {
                type: 'table',
                items: [
                  {
                    value: 'Up to 150% of Insured Trip Cost',
                    group: 'A',
                    title: 'Trip Interruption',
                  },
                  {
                    value: '$2500',
                    group: 'BAG',
                    title: 'Baggage',
                  },
                  {
                    value: '$500',
                    group: 'BAG',
                    title: 'Per Item Limit ',
                  },
                  {
                    value: '$250',
                    group: 'BAGD',
                    title: 'Baggage Delay',
                  },
                  {
                    value: '12',
                    group: 'BAGD',
                    title: 'Hours',
                  },
                  {
                    value: '$500,000 ($50,000 for NH residents)',
                    group: 'B',
                    title: 'Emergency Medical Expense',
                  },
                  {
                    value: '$1000',
                    group: 'C',
                    title: 'Emergency Dental Expense',
                  },
                  {
                    value: '$50,000',
                    group: 'ACD',
                    title: 'Accidental death and dismemberment',
                  },
                  {
                    value: '365',
                    group: 'ACD',
                    title: 'Days',
                  },
                  {
                    value: '$1,000,000',
                    group: 'EMER',
                    title: 'Emergency Evacuation & Repatriation ',
                  },
                  {
                    value: 'Yes',
                    group: 'EMER',
                    title: 'Hospital Choice ',
                  },
                ],
                columnNames: {
                  value: '',
                  title: '',
                },
              },
              {
                type: 'bold',
                value: '\nFull Details',
              },
              {
                type: 'text',
                value:
                  'This is a brief summary of the beneﬁts and coverages provided by this Plan. The full coverage terms and details, including limitations and exclusions, are contained in the insurance policy.',
              },
            ],
            title: "What's covered",
          },
          notCovered: {
            items: [
              {
                type: 'bold',
                value: 'Snapshot',
              },
              {
                type: 'text',
                value: 'A summary of what’s NOT Covered:',
              },
              {
                type: 'bullet',
                value: [
                  'Costs for electronics, phones or sporting equipment over $500.',
                  'Animals, boats, motorcycle, furniture, eyeglasses, contact lenses, sunglasses, prosthetics, musical instruments.',
                  'Sporting equipment in use.',
                  'Items over $500 if you dont have the original receipt.',
                  'Injuries or death sustained while riding or driving in any motor competition; and injuries or death sustained in the service in the armed forces of any country.',
                  'Participation as a professional in athletics or in organized amateur or interscholastic competitions.',
                  'Elective medical or holistic treatment or procedures.',
                  'Sickness, injury or death if insurance is purchased after entering a hospice facility or receiving hospice treatment.',
                  'Trip interruption for any reason outside of the following:\n\n- Sickness, Injury or Death.\n\n- Common Carrier Delay or Cancellation (12 hours).\n\n- Airline, Cruise or Tour Cancellation (12 hours) due to weather, mechanical, strike, or FAA mandate.\n\n- Financial Insolvency\n\n- Traffic Accident En Route to Departure.\n\n- Hijacked, Kidnapped or Quarantined.\n\n- Jury Duty or Witness.\n\n- Uninhabitable or Inaccessible Home.\n\n- Uninhabitable or Inaccessible accommodation at Destination.\n\n- Felonious Assault or Residential Burglary.\n\n- Terrorism.\n\n- Military Obligation.\n\n- Involuntary Employment Termination.\n\n- Required to work.\n\n- Named Hurricane.\n\n- Foreseen events. Cover-More Inc. maintains an updated list of alerts and financial defaults on its website.',
                ],
              },
              {
                type: 'bold',
                value: "\nThings we just don't cover",
              },
              {
                type: 'text',
                value:
                  'Events arising from pre-existing medical conditions, or your pregnancy. You doing an activity that is an exclusion in the Policy. Stuff that happens due to you being drunk or otherwise intoxicated. ',
              },
              {
                type: 'bold',
                value: '\nFull Details',
              },
              {
                type: 'text',
                value:
                  'This is a brief summary of the beneﬁts and coverages provided by this Plan. The full coverage terms and details, including limitations and exclusions, are contained in the insurance policy.',
              },
            ],
            title: "What's not covered",
          },
        },
        market: 'US',
        title: 'The Essentials Plan.',
        version: '2023-03-29',
        preconditionBoostIds: null,
        templateId: 'USTEP',
        subTitle:
          "When you're traveling, we want to make sure your luggage is covered and you're safe and healthy.",
        id: 'USTEP',
        description: '',
        requiredCoverAmount: null,
      },
      startEndDates: [
        {
          startDate: '2023-04-20',
          endDate: '2023-04-21',
        },
      ],
      benefits: [
        {
          description: 'The Essentials Plan.',
          name: 'The Essentials Plan',
        },
      ],
      isAdded: true,
      toUpdate: null,
      isMandatory: true,
      price: '2300',
      boostProperty: {},
      isSelected: true,
      category: BOOST_CATEGORY.MY_STUFF,
      version: '2023-03-29',
      tripId: 'trip_1681429187249_70819c6e-ce82-4406-9e9a-ac917d97c1d9_anonymous',
      boostId: 'boost_1681429190647_b96505af-74eb-47b2-9746-b93c8609f368',
      isEligible: true,
      travellers: null,
      cmName: 'hhh',
      currency: 'AUD',
    },
  ],
  policyStatus: 'NORMAL',
  price: 2300,
  presignedCoiLink: null,
  secondaryTravellers: [],
  destinations: [
    {
      countryCode: 'USA',
      imageLinks: {
        app: 'https://d3taykp79ux94z.cloudfront.net/images/destination-images/app/USA.jpg',
      },
      longName: 'United States',
      countryId: '37',
      emcRiskCode: 201,
    },
  ],
  endDate: '2023-04-21',
  sortKey: 'trip_1681429187249_70819c6e-ce82-4406-9e9a-ac917d97c1d9_anonymous',
  pendingUpdates: null,
  totalTripCost: 66,
  pdsLink: 'https://d3taykp79ux94z.cloudfront.net/public/us/pds/al/2022-05-27/policy.pdf',
  currentScreen: BOOST_CATEGORY.MY_HEALTH,
  depositDate: '2023-04-11',
  policy: null,
  startDate: '2023-04-20',
  tripType: TRIP_TYPE.INTERNATIONAL,
  isTripStarted: false,
  metaData: { excessAmount: 250 },
};

export const boostDetailMock: BoostDetails = {
  cmName: '',
  currency: 'USD',
  hasError: false,
  imageURL: '',
  toggleStatus: null,
  description: 'The Essentials Plan.',
  name: 'The Essentials Plan',
  duration: 2,
  userId: '7ae4313e-c812-4de3-b9d0-5097ee69daa4',
  code: 'USTEP',
  template: {
    pdsLink: {
      title: 'Read our Policy',
      value: 'https://d3taykp79ux94z.cloudfront.net/public/us/pds/al/2022-05-27/policy.pdf',
    },
    inclusions: [
      {
        subTitle: 'If you have to cancel your trip when you are already traveling',
        title: 'Trip Interruption',
        iconPath: '/public/us/boost-images/USOEP-Plane.svg',
      },
      {
        subTitle: 'If your luggage is lost, stolen or damaged. You can upgrade this if you want',
        title: 'Your Luggage',
        iconPath: '/public/us/boost-images/USOEP-Luggage.svg',
      },
      {
        subTitle: 'If you have a medical emergency when traveling',
        title: 'Emergency<br/>Medical Expense',
        iconPath: '/public/us/boost-images/USOEP-Medical.svg',
      },
      {
        subTitle: 'If you need Emergency Dental work when you’re traveling',
        title: 'Emergency<br/>Dental Expense',
        iconPath: '/public/us/boost-images/USOEP-Dental.svg',
      },
    ],
    additionalInformation: {
      heading: 'Additional Information',
      items: [],
    },
    sortKey: '2023-03-29',
    coverDetails: {
      covered: {
        items: [
          {
            type: 'bold',
            value: 'Snapshot',
          },
          {
            type: 'text',
            value: 'A quick summary of what this plan provides coverage for:',
          },
          {
            type: 'bullet',
            value: [
              'Trip Interruption Coverage up to 150% of your pre-paid and non-refundable trip cost if a portion of a trip is missed, or if you must return home early due to unforeseen circumstances, including illness, injury, or death.',
              'Single Occupancy coverage up to 150% of trip cost if your traveling companion interrupts their trip for a covered reason and you choose to still go but have additional costs related to single occupancy.',
              'Reimbursement for direct loss, theft, damage or destruction of baggage, personal eﬀects or passports.',
              'The cost of reasonable additional clothing and personal articles if your luggage is delayed for more than 12 hours.',
              'The costs to expedite the return of delayed or misdirected baggage.',
              'Coverage up to the policy limits below for the costs to treat a medical emergency, including COVID-19, during a trip.',
              'Emergency Medical Transportation & Repatriation to the nearest adequate medical facility or home in the event of a medical emergency during the covered trip.',
            ],
          },
          {
            type: 'bold',
            value: 'Benefits and Coverage Limits',
          },
          {
            type: 'table',
            items: [
              {
                value: 'Up to 150% of Insured Trip Cost',
                group: 'A',
                title: 'Trip Interruption',
              },
              {
                value: '$2500',
                group: 'BAG',
                title: 'Baggage',
              },
              {
                value: '$500',
                group: 'BAG',
                title: 'Per Item Limit ',
              },
              {
                value: '$250',
                group: 'BAGD',
                title: 'Baggage Delay',
              },
              {
                value: '12',
                group: 'BAGD',
                title: 'Hours',
              },
              {
                value: '$500,000 ($50,000 for NH residents)',
                group: 'B',
                title: 'Emergency Medical Expense',
              },
              {
                value: '$1000',
                group: 'C',
                title: 'Emergency Dental Expense',
              },
              {
                value: '$50,000',
                group: 'ACD',
                title: 'Accidental death and dismemberment',
              },
              {
                value: '365',
                group: 'ACD',
                title: 'Days',
              },
              {
                value: '$1,000,000',
                group: 'EMER',
                title: 'Emergency Evacuation & Repatriation ',
              },
              {
                value: 'Yes',
                group: 'EMER',
                title: 'Hospital Choice ',
              },
            ],
            columnNames: {
              value: '',
              title: '',
            },
          },
          {
            type: 'bold',
            value: '\nFull Details',
          },
          {
            type: 'text',
            value:
              'This is a brief summary of the beneﬁts and coverages provided by this Plan. The full coverage terms and details, including limitations and exclusions, are contained in the insurance policy.',
          },
        ],
        title: "What's covered",
      },
      notCovered: {
        items: [
          {
            type: 'bold',
            value: 'Snapshot',
          },
          {
            type: 'text',
            value: 'A summary of what’s NOT Covered:',
          },
          {
            type: 'bullet',
            value: [
              'Costs for electronics, phones or sporting equipment over $500.',
              'Animals, boats, motorcycle, furniture, eyeglasses, contact lenses, sunglasses, prosthetics, musical instruments.',
              'Sporting equipment in use.',
              'Items over $500 if you dont have the original receipt.',
              'Injuries or death sustained while riding or driving in any motor competition; and injuries or death sustained in the service in the armed forces of any country.',
              'Participation as a professional in athletics or in organized amateur or interscholastic competitions.',
              'Elective medical or holistic treatment or procedures.',
              'Sickness, injury or death if insurance is purchased after entering a hospice facility or receiving hospice treatment.',
              'Trip interruption for any reason outside of the following:\n\n- Sickness, Injury or Death.\n\n- Common Carrier Delay or Cancellation (12 hours).\n\n- Airline, Cruise or Tour Cancellation (12 hours) due to weather, mechanical, strike, or FAA mandate.\n\n- Financial Insolvency\n\n- Traffic Accident En Route to Departure.\n\n- Hijacked, Kidnapped or Quarantined.\n\n- Jury Duty or Witness.\n\n- Uninhabitable or Inaccessible Home.\n\n- Uninhabitable or Inaccessible accommodation at Destination.\n\n- Felonious Assault or Residential Burglary.\n\n- Terrorism.\n\n- Military Obligation.\n\n- Involuntary Employment Termination.\n\n- Required to work.\n\n- Named Hurricane.\n\n- Foreseen events. Cover-More Inc. maintains an updated list of alerts and financial defaults on its website.',
            ],
          },
          {
            type: 'bold',
            value: "\nThings we just don't cover",
          },
          {
            type: 'text',
            value:
              'Events arising from pre-existing medical conditions, or your pregnancy. You doing an activity that is an exclusion in the Policy. Stuff that happens due to you being drunk or otherwise intoxicated. ',
          },
          {
            type: 'bold',
            value: '\nFull Details',
          },
          {
            type: 'text',
            value:
              'This is a brief summary of the beneﬁts and coverages provided by this Plan. The full coverage terms and details, including limitations and exclusions, are contained in the insurance policy.',
          },
        ],
        title: "What's not covered",
      },
    },
    market: 'US',
    title: 'The Essentials Plan.',
    version: '2023-03-29',
    preconditionBoostIds: null,
    templateId: 'USTEP',
    subTitle:
      "When you're traveling, we want to make sure your luggage is covered and you're safe and healthy.",
    id: 'USTEP',
    description: '',
    requiredCoverAmount: null,
  },
  startEndDates: [
    {
      startDate: '2023-04-20',
      endDate: '2023-04-21',
    },
  ],
  benefits: [
    {
      description: 'The Essentials Plan.',
      name: 'The Essentials Plan',
    },
  ],
  isAdded: true,
  toUpdate: null,
  isMandatory: true,
  price: '2300',
  boostProperty: {},
  isSelected: true,
  category: BOOST_CATEGORY.MY_HEALTH,
  version: '2023-03-29',
  tripId: 'trip_1681429187249_70819c6e-ce82-4406-9e9a-ac917d97c1d9_anonymous',
  boostId: 'boost_1681429190647_b96505af-74eb-47b2-9746-b93c8609f368',
  isEligible: true,
  travellers: null,
};

export const tripMockAUQuote: Trip = {
  sortKey: 'trip_1692753276025_007c410e-5a1d-4359-9db5-374e6e0d344b',
  startDate: '2023-08-24',
  endDate: '2023-08-29',
  productId: '',

  destinations: [
    {
      longName: 'Bali',
      countryId: '124',
      countryCode: 'IDN',
      imageLinks: {
        mobile: 'https://d3taykp79ux94z.cloudfront.net/images/destination-images/mobile/Bali.jpg',
        desktop: 'https://d3taykp79ux94z.cloudfront.net/images/destination-images/desktop/Bali.jpg',
        tablet: 'https://d3taykp79ux94z.cloudfront.net/images/destination-images/tablet/Bali.jpg',
      },
      emcRiskCode: 201,
    },
  ],
  secondaryTravellers: [],
  state: TRIP_STATUS.PAID,
  tripType: TRIP_TYPE.INTERNATIONAL,
  price: 4700,
  isTripStarted: false,
  hasAddedBoosts: true,
  primaryTravellerId: '91ca4988-13cd-4c94-8e28-d4bcc870f70b',

  boosts: [
    {
      tripId: 'trip_1692753276025_007c410e-5a1d-4359-9db5-374e6e0d344b',
      boostId: 'boost_1692753278608_e0079ff4-d229-42ca-a239-8f5c222cf79a',
      userId: '91ca4988-13cd-4c94-8e28-d4bcc870f70b',
      code: 'OMD',
      name: 'Overseas Explorer',
      cmName: 'Oversea medical and dental',
      benefits: [
        {
          name: 'Overseas Explorer',
          description: 'Overseas Medical and Dental',
        },
      ],
      price: '4700',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [
        {
          endDate: '2023-08-29',
          startDate: '2023-08-24',
        },
      ],
      duration: 6,
      boostProperty: {},
      isMandatory: true,
      template: {
        pdsLink: {
          title: 'See PDS for detailed information',
          value: 'https://d3taykp79ux94z.cloudfront.net/public/au/pds/2023-08-30/pds.pdf',
        },
        market: 'AU',
        preconditionBoostIds: null,
        version: '2023-05-03',
        requiredCoverAmount: null,
        templateId: 'OMD',
        subTitle:
          "All benefits on this On-Trip Policy have a $250 excess. The excess is the first amount of a claim that we won't pay for under some benefits. It is deducted from your claim if it is approved by us.",
        boostMessage:
          "There are certain things that really should be covered when you go away, so we've grouped them into our Overseas Explorer Plan to make it easier for you. Here is a snapshot of some of the benefits:",
        additionalInformation: {
          heading: 'Additional Information',
          items: [
            {
              title: "Things we just don't cover",
              description:
                'You doing an activity that is an exclusion in the Policy. Stuﬀ that happens due to you being drunk or otherwise intoxicated.',
            },
            {
              title: 'Prices & benefits may change',
              description: 'Quote, benefits or product offered is subject to change at any time.',
            },
            {
              title: 'Special Excess',
              description:
                "If you're diagnosed with COVID-19 on your trip, a special excess of $250 applies for cancellation costs and additional expenses in addition to the $50 standard excess.",
            },
            {
              title: 'Existing Medical Conditions',
              description:
                "We automatically include a number of Existing Medical Conditions, please read our PDS for a complete list of what is and isn't covered.",
            },
            {
              title: 'Full details',
              description:
                'This is a brief summary of the beneﬁts and coverages provided by this Trip Extra or Daily Boost. The full coverage terms and details, including limitations and exclusions, are contained in the insurance policy.',
            },
          ],
        },
        categoryCaption: 'MANDATORY',
        sortKey: '2023-05-03',
        inclusions: [
          {
            description:
              'If you become sick or injured while on your trip, we provide cover for unexpected medical and hospital expenses.',
            iconPath: '/public/au/boost-images/ambulance.svg',
            title: 'Overseas Medical',
            subTitle: '$Unlimited',
          },
          {
            description:
              'If you need to pay for unexpected dental treatment during your trip, we can provide cover for emergency overseas dental expenses.',
            iconPath: '/public/au/boost-images/dental.svg',
            title: 'Emergency Dental',
            subTitle: '$Unlimited',
          },
          {
            description:
              'If you become sick or injured while on your trip, we provide cover for the usual and customary cost of unexpected medical and hospital expenses incurred overseas.',
            iconPath: '/public/au/boost-images/covid.svg',
            title: 'COVID-19 Cover',
            subTitle: '$Unlimited',
          },
          {
            description:
              'If your luggage or travel documents are lost, stolen, or damaged on your trip, we can reimburse you for the cost of replacing or repairing your items.',
            iconPath: '/public/au/boost-images/lugguage.svg',
            title: 'Luggage Cover',
            subTitle: '$10,000',
          },
          {
            description:
              'If your luggage is delayed by a transport provider for more than 12 hours during your trip, we can reimburse you for the costs of several personal items purchased.',
            iconPath: '/public/au/boost-images/lugguage-delay.svg',
            title: 'Luggage Delay',
            subTitle: '$1,000',
          },
          {
            description:
              'If you encounter unexpected accommodation and/or transport costs during your travels because of a covered event, we can provide cover for the additional expenses you incur.',
            iconPath: '/public/au/boost-images/wallet.svg',
            title: 'Additional Expenses',
            subTitle: '$Unlimited',
          },
          {
            description:
              'If you need to unexpectedly amend or cancel your trip for a covered reason, we can reimburse you for the costs of your prepaid, non-refundable travel arrangements.',
            iconPath: '/public/au/boost-images/cancel.svg',
            title: 'Cancellation Cover',
            subTitle: '$5,000',
          },
          {
            description:
              "If you need to return to Australia while you're on your trip because of the sudden serious injury, sickness, disease, or death of your relative or business partner.",
            iconPath: '/public/au/boost-images/world-plane.svg',
            title: 'Resumption of Journey',
            subTitle: '$2,000',
          },
          {
            description:
              "If you become unintentionally legally liable to pay compensation for damage caused to someone else's property or for the injury or death of someone .",
            iconPath: '/public/au/boost-images/legal.svg',
            title: 'Personal Liability',
            subTitle: '$3,000,000',
          },
        ],
        coverDetails: {
          covered: {
            title: "What's covered",
            items: [
              {
                type: 'bold',
                value: 'Snapshot',
              },
              {
                type: 'text',
                value: 'A quick summary of what the Overseas Explorer Plan covers you for:',
              },
              {
                type: 'bullet',
                value: [
                  'Unlimited overseas medical expenses.',
                  'Emergency repatriation or evacuation.',
                  'If you have to come back to Australia for unforeseen reasons.',
                  'If you lose your passport or travel documents.',
                  'If you die or are disabled during your trip.',
                  'If your luggage, personal effects, money, passport or travel documents are lost, stolen or damaged, we will repair, replace or pay you the monetary value of the item, less any depreciation that applies, up to the combined value of AU$10,000. Item limits apply.',
                  'If your trip has to be cancelled we will compensate you up to the value of AU$5,000.',
                ],
              },
              {
                title: 'Benefits & Limits',
                type: 'sheet-table',
                tables: [
                  {
                    columnNames: {
                      title: 'Your Trip',
                      value: 'Cover',
                    },
                    items: [
                      {
                        title: 'Cancellation and Amendments',
                        value: '$5,000',
                      },
                      {
                        title: 'Travel Delay Expenses',
                        value: '$2,000',
                      },
                      {
                        title: 'Resumption of Journey',
                        value: '$2,000',
                      },
                      {
                        title: 'Special Events',
                        value: '$2,000',
                      },
                    ],
                  },
                  {
                    columnNames: {
                      title: 'Your Health',
                      value: 'Cover',
                    },
                    items: [
                      {
                        title: 'Overseas Medical & Dental',
                        value: '$Unlimited',
                      },
                      {
                        title: 'Accidental Death',
                        value: '$25,000',
                      },
                      {
                        title: 'Disability',
                        value: '$25,000',
                      },
                    ],
                  },
                  {
                    columnNames: {
                      title: 'Your Stuff',
                      value: 'Cover',
                    },
                    items: [
                      {
                        title: 'Luggage',
                        value: '$10,000',
                        child: {
                          title: 'Each specific item',
                          value: '$750',
                        },
                      },
                      {
                        title: 'Luggage Delay',
                        value: '$1,000',
                      },
                      {
                        title: 'Money',
                        value: '$500',
                      },
                      {
                        title: 'Passport & Travel Documents',
                        value: '$1,000',
                      },
                    ],
                  },
                  {
                    columnNames: {
                      title: 'Other',
                      value: 'Cover',
                    },
                    items: [
                      {
                        title: 'Personal Liability',
                        value: '$3,000,000',
                      },
                      {
                        title: 'Additional Expenses',
                        value: '$Unlimited',
                      },
                    ],
                  },
                  {
                    columnNames: {
                      title: 'Your Excess',
                      value: 'Cover',
                    },
                    items: [
                      {
                        title: 'Excess',
                        value: '$250',
                      },
                    ],
                  },
                ],
              },
              {
                type: 'bold',
                value: '\nExisting Medical Conditions',
              },
              {
                type: 'text',
                value:
                  "We automatically include a number of Existing Medical Conditions, please read our PDS for a complete list of what is and isn't covered.",
              },
              {
                type: 'bold',
                value: '\nPrices & benefits may change',
              },
              {
                type: 'text',
                value: 'Quote, benefits or product offered is subject to change at any time.',
              },
              {
                type: 'bold',
                value: '\nSome limits apply',
              },
              {
                type: 'text',
                value:
                  'Medical and dental will not exceed 12 months from onset of the illness or injury. Liability may not exceed $25,000 on Overseas Explorer Plan or $10,000 on Domestic Explorer Plan. Limits, sub-limits, conditions and exclusions apply. Please read our PDS for the full details.',
              },
              {
                type: 'bold',
                value: '\nFull details',
              },
              {
                type: 'text',
                value:
                  'This is a summary of the additional benefits provided by this Explorer plan. For a really detailed (and we mean really detailed) description, read the PDS.',
              },
            ],
          },
          notCovered: {
            title: "What's not covered",
            items: [
              {
                type: 'bold',
                value: 'Snapshot',
              },
              {
                type: 'text',
                value: "A summary of what's NOT Covered:",
              },
              {
                type: 'bullet',
                value: [
                  'Any medical costs in Australia - whether before or after your trip.',
                  'Routine medical or dental treatments.',
                  'Continuation of treatment or follow ups for treatment started prior to your journey.',
                  'Any issues arising from you transmitting an illness, sickness or disease.',
                  'Medical or dental costs after 12 months from onset of illness or injury.',
                  'Items when they are in use, such as drones, sporting equipment, or financial instruments.',
                  'Things that are just neglected or items left unattended in a public place might not be covered either.',
                  'Travel Delay, including to Special Events, if caused by an Epidemic or Pandemic outbreak.',
                  'Resumption of Journey unless trip is over 23 days and your return happens in the first half.',
                ],
              },
              {
                type: 'bold',
                value: "\nThings we just don't cover",
              },
              {
                type: 'text',
                value:
                  'Events arising from pre-existing medical conditions, or your pregnancy. You doing an activity that is an exclusion in the Policy. Stuff that happens due to you being drunk or otherwise intoxicated.',
              },
              {
                type: 'bold',
                value: '\nPrices & benefits may change',
              },
              {
                type: 'text',
                value: 'Quote, benefits or product offered is subject to change at any time.',
              },
              {
                type: 'bold',
                value: '\nFull details',
              },
              {
                type: 'text',
                value:
                  'This is a summary of the additional benefits provided by this Explorer plan. For a really detailed (and we mean really detailed) description, read the PDS.',
              },
            ],
          },
        },
        description:
          "All benefits on this On-Trip Policy have a $250 excess. The excess is the first amount of a claim that we won't pay for under some benefits. It is deducted from your claim if it is approved by us.",
        id: 'OMD',
        title: 'Overseas Explorer',
      },
      isAdded: true,
      isSelected: true,
      category: BOOST_CATEGORY.MY_HEALTH,
      description: 'Overseas Medical and Dental',
      toUpdate: null,
      travellers: null,
      imageURL: null,
      toggleStatus: null,
    },
    {
      tripId: 'trip_1692753276025_007c410e-5a1d-4359-9db5-374e6e0d344b',
      boostId: 'boost_1692753278608_c1f7e68f-6bb0-433e-aaf4-974b013f4eb1',
      userId: '91ca4988-13cd-4c94-8e28-d4bcc870f70b',
      code: 'CANX',
      name: 'Extra Cancellation',
      cmName: 'Cancellation Variation',
      benefits: [
        {
          name: 'Extra Cancellation',
          description:
            'For flights and accommodation worth more than $5,000, you can increase your coverage.',
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [
        {
          endDate: '2023-08-29',
          startDate: '2023-08-24',
        },
      ],
      duration: 6,
      boostProperty: {
        coverAmountValues: [
          1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000, 13000, 14000,
          15000, 40000,
        ],
        options: [
          {
            value: 0,
            description: '$5,000',
          },
          {
            value: 1000,
            description: '$6,000',
          },
          {
            value: 2000,
            description: '$7,000',
          },
          {
            value: 3000,
            description: '$8,000',
          },
          {
            value: 4000,
            description: '$9,000',
          },
          {
            value: 5000,
            description: '$10,000',
          },
          {
            value: 6000,
            description: '$11,000',
          },
          {
            value: 7000,
            description: '$12,000',
          },
          {
            value: 8000,
            description: '$13,000',
          },
          {
            value: 9000,
            description: '$14,000',
          },
          {
            value: 10000,
            description: '$15,000',
          },
          {
            value: 11000,
            description: '$16,000',
          },
          {
            value: 12000,
            description: '$17,000',
          },
          {
            value: 13000,
            description: '$18,000',
          },
          {
            value: 14000,
            description: '$19,000',
          },
          {
            value: 15000,
            description: '$20,000',
          },
          {
            value: 40000,
            description: '$Unlimited',
          },
        ],
        selectedExtraCover: null,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_STUFF,
      description:
        'For flights and accommodation worth more than $5,000, you can increase your coverage.',
      toUpdate: null,
      travellers: null,
      imageURL:
        'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/extra_cancellation.png',
    },
    {
      tripId: 'trip_1692753276025_007c410e-5a1d-4359-9db5-374e6e0d344b',
      boostId: 'boost_1692753278608_17a561d1-a7c7-45d6-9f21-7bb93bba5e7a',
      userId: '91ca4988-13cd-4c94-8e28-d4bcc870f70b',
      code: 'GADGFREE',
      name: 'Gadget Cover',
      cmName: 'Gadget Cover (Freely)',
      benefits: [
        {
          name: 'Gadget Cover',
          description:
            'Increase the limit for all your laptops, phones or drones worth more than $750.',
        },
      ],
      price: '6500',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [
        {
          endDate: '2023-08-29',
          startDate: '2023-08-24',
        },
      ],
      duration: 6,
      boostProperty: {},
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_STUFF,
      description:
        'Increase the limit for all your laptops, phones or drones worth more than $750.',
      toUpdate: null,
      travellers: null,
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/gadget_cover.png',
    },
    {
      tripId: 'trip_1692753276025_007c410e-5a1d-4359-9db5-374e6e0d344b',
      boostId: 'boost_1692753278608_c82720c6-6c30-4716-bb5a-5070fcf5efc8',
      userId: '91ca4988-13cd-4c94-8e28-d4bcc870f70b',
      code: 'LUGG',
      name: 'Specified Items',
      cmName: 'Increase Luggage Item Limits',
      benefits: [
        {
          name: 'Specified Items',
          description: 'Get extra cover for specific items worth more than $750.',
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [
        {
          endDate: '2023-08-29',
          startDate: '2023-08-24',
        },
      ],
      duration: 6,
      boostProperty: {
        coverAmountValues: [500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000],
        basePrice: 1700,
        specifiedItems: [],
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_STUFF,
      description: 'Get extra cover for specific items worth more than $750.',
      toUpdate: null,
      travellers: [
        {
          isPrimary: true,
          sortKey: '91ca4988-13cd-4c94-8e28-d4bcc870f70b',
          dob: '2000-02-12',
          isAdult: true,
          firstName: 'John',
          lastName: 'Doe',
          isDependant: false,
          isResident: true,
        },
      ],
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/specified_items.png',
    },
    {
      tripId: 'trip_1692753276025_007c410e-5a1d-4359-9db5-374e6e0d344b',
      boostId: 'boost_1692753278608_cedff6b3-4836-481f-9add-e0ddfced7008',
      userId: '91ca4988-13cd-4c94-8e28-d4bcc870f70b',
      code: 'SSPFREE',
      name: 'Snow Sports',
      cmName: 'Snow Sports + (Freely)',
      benefits: [
        {
          name: 'Snow Sports',
          description:
            'Going Off-Piste? This covers you for snow skiing, boarding, mobiling, heli-skiing and more.',
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [],
      duration: 0,
      boostProperty: {
        payPerDayRate: 1000,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_ACTIVITIES,
      description:
        'Going Off-Piste? This covers you for snow skiing, boarding, mobiling, heli-skiing and more.',
      toUpdate: null,
      travellers: null,
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/snow_activities.png',
    },
    {
      tripId: 'trip_1692753276025_007c410e-5a1d-4359-9db5-374e6e0d344b',
      boostId: 'boost_1692753278608_56119547-55b2-4b76-bfd0-9103021fb773',
      userId: '91ca4988-13cd-4c94-8e28-d4bcc870f70b',
      code: 'CRSF',
      name: 'Cruise Cover',
      cmName: 'Cruise (Freely)',
      benefits: [
        {
          name: 'Cruise Cover',
          description: 'Will you be travelling for two or more nights on a cruise?',
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [],
      duration: 0,
      boostProperty: {
        payPerDayRate: 800,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_ACTIVITIES,
      description: 'Will you be travelling for two or more nights on a cruise?',
      toUpdate: null,
      travellers: null,
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/cruise_cover.png',
    },
    {
      tripId: 'trip_1692753276025_007c410e-5a1d-4359-9db5-374e6e0d344b',
      boostId: 'boost_1692753278608_09090dad-294b-4936-b7f7-87b62dcc073b',
      userId: '91ca4988-13cd-4c94-8e28-d4bcc870f70b',
      code: 'RCUF',
      name: 'Rental Insurance Excess',
      cmName: 'Rental Vehicle Insurance Excess (Freely)',
      benefits: [
        {
          name: 'Rental Insurance Excess',
          description: "If something goes wrong we'll pay the Car Rental Insurance Excess.",
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [],
      duration: 0,
      boostProperty: {
        payPerDayRate: 800,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_ACTIVITIES,
      description: "If something goes wrong we'll pay the Car Rental Insurance Excess.",
      toUpdate: null,
      travellers: null,
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/rental_ensurance.png',
    },
    {
      tripId: 'trip_1692753276025_007c410e-5a1d-4359-9db5-374e6e0d344b',
      boostId: 'boost_1692753278608_4fa1d46f-31cf-44cb-a571-e615b97d67ea',
      userId: '91ca4988-13cd-4c94-8e28-d4bcc870f70b',
      code: 'ADVACT4',
      name: 'Adventure Activities',
      cmName: 'Adventure Activities (Freely)',
      benefits: [
        {
          name: 'Adventure Activities',
          description: 'Get your adrenaline rush on without breaking the bank.',
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [],
      duration: 0,
      boostProperty: {
        payPerDayRate: 700,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_ACTIVITIES,
      description: 'Get your adrenaline rush on without breaking the bank.',
      toUpdate: null,
      travellers: null,
      imageURL:
        'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/adventure_activities.png',
    },
    {
      tripId: 'trip_1692753276025_007c410e-5a1d-4359-9db5-374e6e0d344b',
      boostId: 'boost_1692753278608_ca932591-1c78-43d5-8844-8d85bbfe266e',
      userId: '91ca4988-13cd-4c94-8e28-d4bcc870f70b',
      code: 'MTCL4',
      name: 'Motorbike Cover',
      cmName: 'Motorcycle + (Freely)',
      benefits: [
        {
          name: 'Motorbike Cover',
          description:
            'For people wanting to ride a motorcycle, moped or scooter as a driver or passenger.',
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [],
      duration: 0,
      boostProperty: {
        payPerDayRate: 700,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_ACTIVITIES,
      description:
        'For people wanting to ride a motorcycle, moped or scooter as a driver or passenger.',
      toUpdate: null,
      travellers: null,
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/motobike_cover.png',
    },
  ],
  pdsLink: 'https://d3taykp79ux94z.cloudfront.net/public/au/pds/2023-08-30/pds.pdf',
  presignedCoiLink: null,
  pendingUpdates: null,
  policy: null,
  policyStatus: 'NORMAL',
  currentScreen: BOOST_CATEGORY.MY_HEALTH,
  primaryTraveller: {
    dob: '2000-02-12',
    firstName: '',
    lastName: '',
    isResident: true,
  },
  metaData: {
    excessAmount: 250,
  },
};

export const tripSelectedBoost: Trip = {
  sortKey: 'trip_1702430692324_29292dd9-9cde-47a0-a204-93ffab870d1f',
  primaryTravellerId: '07b2257d-4f70-4e2b-be26-9ad7a87fc0f5',
  hasAddedBoosts: true,
  productId: '',
  startDate: '2023-12-14',
  endDate: '2023-12-27',
  destinations: [
    {
      isCity: false,
      countryCode: 'CHN',
      countryFlagImage: 'https://d3taykp79ux94z.cloudfront.net/images/flags/cn.png',
      countryName: 'China',
      category: 'allDestinations',
      countryId: '121',
      longName: 'China',
      imageLinks: {
        mobile:
          'https://d3taykp79ux94z.cloudfront.net/images/destination-images/mobile/International_Default.jpg',
        desktop:
          'https://d3taykp79ux94z.cloudfront.net/images/destination-images/desktop/International_Default.jpg',
        tablet:
          'https://d3taykp79ux94z.cloudfront.net/images/destination-images/tablet/International_Default.jpg',
      },
      isTrending: true,
      emcRiskCode: 201,
    },
  ],
  primaryTraveller: {
    dob: '2000-02-12',
    firstName: '',
    lastName: '',
    isResident: true,
  },
  secondaryTravellers: [],
  state: TRIP_STATUS.NO_BOOST,
  tripType: TRIP_TYPE.INTERNATIONAL,
  price: 12900,
  isTripStarted: false,

  boosts: [
    {
      tripId: 'trip_1702430692324_29292dd9-9cde-47a0-a204-93ffab870d1f',
      boostId: 'boost_1702430692325_098bb1a0-3b69-462a-b8d0-d3fea4e7ebda',
      userId: '07b2257d-4f70-4e2b-be26-9ad7a87fc0f5',
      code: 'OMD',
      name: 'Overseas Explorer',
      cmName: 'Oversea medical and dental',
      benefits: [
        {
          name: 'Overseas Explorer',
          description: 'Overseas Medical and Dental',
        },
      ],
      price: '7900',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [
        {
          endDate: '2023-12-27',
          startDate: '2023-12-14',
        },
      ],
      duration: 14,
      boostProperty: {},
      isMandatory: true,
      template: {
        pdsLink: {
          title: 'See PDS for detailed information',
          value: 'https://d3taykp79ux94z.cloudfront.net/public/au/pds/2023-08-30/pds.pdf',
        },
        market: 'US',
        preconditionBoostIds: null,
        version: '2023-05-03',
        requiredCoverAmount: null,
        templateId: 'OMD',
        subTitle:
          "All benefits on this On-Trip Policy have a $250 excess. The excess is the first amount of a claim that we won't pay for under some benefits. It is deducted from your claim if it is approved by us.",
        boostMessage:
          "There are certain things that really should be covered when you go away, so we've grouped them into our Overseas Explorer Plan to make it easier for you. Here is a snapshot of some of the benefits:",
        additionalInformation: {
          heading: 'Additional Information',
          items: [
            {
              title: "Things we just don't cover",
              description:
                'You doing an activity that is an exclusion in the Policy. Stuﬀ that happens due to you being drunk or otherwise intoxicated.',
            },
            {
              title: 'Prices & benefits may change',
              description: 'Quote, benefits or product offered is subject to change at any time.',
            },
            {
              title: 'Existing Medical Conditions',
              description:
                "We automatically include a number of Existing Medical Conditions, please read our PDS for a complete list of what is and isn't covered.",
            },
            {
              title: 'Special Excess',
              description:
                "If you're diagnosed with COVID-19 on your trip, a special excess of $500 applies for cancellation costs and $250 for additional expenses in addition to the $250 standard excess.",
            },
            {
              title: 'Full details',
              description:
                'This is a brief summary of the beneﬁts and coverages provided by this plan. The full coverage terms and details, including limitations and exclusions, are contained in the insurance policy.',
            },
          ],
        },
        categoryCaption: 'MANDATORY',
        sortKey: '2023-05-03',
        inclusions: [
          {
            description:
              'If you become sick or injured while on your trip, we provide cover for unexpected medical and hospital expenses.',
            iconPath: '/public/au/boost-images/ambulance.svg',
            title: 'Overseas Medical',
            subTitle: 'Unlimited',
          },
          {
            description:
              'If you need to pay for unexpected dental treatment during your trip, we can provide cover for emergency overseas dental expenses.',
            iconPath: '/public/au/boost-images/dental.svg',
            title: 'Emergency Dental',
            subTitle: 'Unlimited',
          },
          {
            description:
              'If you become sick or injured while on your trip, we provide cover for the usual and customary cost of unexpected medical and hospital expenses incurred overseas.',
            iconPath: '/public/au/boost-images/covid.svg',
            title: 'COVID-19 Overseas Medical',
            subTitle: 'Unlimited',
          },
          {
            description:
              'If your luggage or travel documents are lost, stolen, or damaged on your trip, we can reimburse you for the cost of replacing or repairing your items.',
            iconPath: '/public/au/boost-images/lugguage.svg',
            title: 'Luggage Cover',
            subTitle: '$10,000',
          },
          {
            description:
              'If your luggage is delayed by a transport provider for more than 12 hours during your trip, we can reimburse you for the costs of several personal items purchased.',
            iconPath: '/public/au/boost-images/lugguage-delay.svg',
            title: 'Luggage Delay',
            subTitle: '$1,000',
          },
          {
            description:
              'If you encounter unexpected accommodation and/or transport costs during your travels because of a covered event, we can provide cover for the additional expenses you incur.',
            iconPath: '/public/au/boost-images/wallet.svg',
            title: 'Additional Expenses',
            subTitle: 'Unlimited',
          },
          {
            description:
              'If you need to unexpectedly amend or cancel your trip for a covered reason, we can reimburse you for the costs of your prepaid, non-refundable travel arrangements.',
            iconPath: '/public/au/boost-images/cancel.svg',
            title: 'Cancellation Cover',
            subTitle: '$5,000',
          },
          {
            description:
              "If you need to return to Australia while you're on your trip because of the sudden serious injury, sickness, disease, or death of your relative or business partner.",
            iconPath: '/public/au/boost-images/world-plane.svg',
            title: 'Resumption of Journey',
            subTitle: '$2,000',
          },
          {
            description:
              "If you become unintentionally legally liable to pay compensation for damage caused to someone else's property or for the injury or death of someone.",
            iconPath: '/public/au/boost-images/legal.svg',
            title: 'Personal Liability',
            subTitle: '$3,000,000',
          },
        ],
        coverDetails: {
          covered: {
            title: "What's covered",
            items: [
              {
                type: 'bold',
                value: 'Snapshot',
              },
              {
                type: 'text',
                value: 'A quick summary of what the Overseas Explorer Plan covers you for:',
              },
              {
                type: 'bullet',
                value: [
                  'Unlimited overseas medical expenses.',
                  'Emergency repatriation or evacuation.',
                  'If you have to come back to Australia for unforeseen reasons.',
                  'If you lose your passport or travel documents.',
                  'If you die or are disabled during your trip.',
                  'If your luggage, personal effects, money, passport or travel documents are lost, stolen or damaged, we will repair, replace or pay you the monetary value of the item, less any depreciation that applies, up to the combined value of AU$10,000. Item limits apply.',
                  'If your trip has to be cancelled we will compensate you up to the value of AU$5,000.',
                ],
              },
              {
                title: 'Benefits & Limits',
                type: 'sheet-table',
                tables: [
                  {
                    columnNames: {
                      title: 'Your Trip',
                      value: '',
                    },
                    items: [
                      {
                        title: 'Cancellation and Amendments',
                        value: '$5,000',
                      },
                      {
                        title: 'Travel Delay Expenses',
                        value: '$2,000',
                      },
                      {
                        title: 'Resumption of Journey',
                        value: '$2,000',
                      },
                      {
                        title: 'Special Events',
                        value: '$2,000',
                      },
                    ],
                  },
                  {
                    columnNames: {
                      title: 'Your Health',
                      value: '',
                    },
                    items: [
                      {
                        title: 'Overseas Medical & Dental',
                        value: 'Unlimited',
                      },
                      {
                        title: 'Accidental Death',
                        value: '$25,000',
                      },
                      {
                        title: 'Disability',
                        value: '$25,000',
                      },
                    ],
                  },
                  {
                    columnNames: {
                      title: 'Your Stuff',
                      value: '',
                    },
                    items: [
                      {
                        title: 'Luggage',
                        value: '$10,000',
                        child: {
                          title: 'Each specific item',
                          value: '$750',
                        },
                      },
                      {
                        title: 'Luggage Delay',
                        value: '$1,000',
                      },
                      {
                        title: 'Money',
                        value: '$500',
                      },
                      {
                        title: 'Passport & Travel Documents',
                        value: '$1,000',
                      },
                    ],
                  },
                  {
                    columnNames: {
                      title: 'Other',
                      value: '',
                    },
                    items: [
                      {
                        title: 'Personal Liability',
                        value: '$3,000,000',
                      },
                      {
                        title: 'Additional Expenses',
                        value: 'Unlimited',
                      },
                    ],
                  },
                  {
                    columnNames: {
                      title: 'Your Excess',
                      value: '',
                    },
                    items: [
                      {
                        title: 'Excess',
                        value: '$250',
                      },
                    ],
                  },
                ],
              },
              {
                type: 'bold',
                value: '\nExisting Medical Conditions',
              },
              {
                type: 'text',
                value:
                  "We automatically include a number of Existing Medical Conditions, please read our PDS for a complete list of what is and isn't covered.",
              },
              {
                type: 'bold',
                value: '\nPrices & benefits may change',
              },
              {
                type: 'text',
                value: 'Quote, benefits or product offered is subject to change at any time.',
              },
              {
                type: 'bold',
                value: '\nSome limits apply',
              },
              {
                type: 'text',
                value:
                  'Medical and dental will not exceed 12 months from onset of the illness or injury. Liability may not exceed $25,000 on Overseas Explorer Plan or $10,000 on Domestic Explorer Plan. Limits, sub-limits, conditions and exclusions apply. Please read our PDS for the full details.',
              },
              {
                type: 'bold',
                value: '\nFull details',
              },
              {
                type: 'text',
                value:
                  'This is a brief summary of the beneﬁts and coverages provided by this plan. The full coverage terms and details, including limitations and exclusions, are contained in the insurance policy.',
              },
            ],
          },
          notCovered: {
            title: "What's not covered",
            items: [
              {
                type: 'bold',
                value: 'Snapshot',
              },
              {
                type: 'text',
                value: "A summary of what's NOT Covered:",
              },
              {
                type: 'bullet',
                value: [
                  'Any medical costs in Australia - whether before or after your trip.',
                  'Routine medical or dental treatments.',
                  'Continuation of treatment or follow ups for treatment started prior to your journey.',
                  'Any issues arising from you transmitting an illness, sickness or disease.',
                  'Medical or dental costs after 12 months from onset of illness or injury.',
                  'Items when they are in use, such as drones, sporting equipment, or financial instruments.',
                  'Things that are just neglected or items left unattended in a public place might not be covered either.',
                  'Travel Delay, including to Special Events, if caused by an Epidemic or Pandemic outbreak.',
                  'Resumption of Journey unless trip is over 23 days and your return happens in the first half.',
                ],
              },
              {
                type: 'bold',
                value: "\nThings we just don't cover",
              },
              {
                type: 'text',
                value:
                  'Events arising from pre-existing medical conditions, or your pregnancy. You doing an activity that is an exclusion in the Policy. Stuff that happens due to you being drunk or otherwise intoxicated.',
              },
              {
                type: 'bold',
                value: '\nPrices & benefits may change',
              },
              {
                type: 'text',
                value: 'Quote, benefits or product offered is subject to change at any time.',
              },
              {
                type: 'bold',
                value: '\nFull details',
              },
              {
                type: 'text',
                value:
                  'This is a brief summary of the beneﬁts and coverages provided by this plan. The full coverage terms and details, including limitations and exclusions, are contained in the insurance policy.',
              },
            ],
          },
        },
        description:
          "All benefits on this On-Trip Policy have a $250 excess. The excess is the first amount of a claim that we won't pay for under some benefits. It is deducted from your claim if it is approved by us.",
        id: 'OMD',
        title: 'Overseas Explorer',
      },
      isAdded: true,
      isSelected: false,
      category: BOOST_CATEGORY.MY_HEALTH,
      description: 'Overseas Medical and Dental',
      toUpdate: null,
      travellers: null,
      imageURL: null,
    },
    {
      tripId: 'trip_1702430692324_29292dd9-9cde-47a0-a204-93ffab870d1f',
      boostId: 'boost_1702430692377_89b79091-213c-42d7-9f88-3b0fca56a0db',
      userId: '07b2257d-4f70-4e2b-be26-9ad7a87fc0f5',
      code: 'CANX',
      name: 'Extra Cancellation',
      cmName: 'Cancellation Variation',
      benefits: [
        {
          name: 'Extra Cancellation',
          description:
            'For flights and accommodation worth more than $5,000, you can increase your coverage.',
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [
        {
          endDate: '2023-12-27',
          startDate: '2023-12-14',
        },
      ],
      duration: 14,
      boostProperty: {
        coverAmountValues: [
          1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000, 13000, 14000,
          15000, 40000,
        ],
        options: [
          {
            value: 0,
            description: '$5,000',
          },
          {
            value: 1000,
            description: '$6,000',
          },
          {
            value: 2000,
            description: '$7,000',
          },
          {
            value: 3000,
            description: '$8,000',
          },
          {
            value: 4000,
            description: '$9,000',
          },
          {
            value: 5000,
            description: '$10,000',
          },
          {
            value: 6000,
            description: '$11,000',
          },
          {
            value: 7000,
            description: '$12,000',
          },
          {
            value: 8000,
            description: '$13,000',
          },
          {
            value: 9000,
            description: '$14,000',
          },
          {
            value: 10000,
            description: '$15,000',
          },
          {
            value: 11000,
            description: '$16,000',
          },
          {
            value: 12000,
            description: '$17,000',
          },
          {
            value: 13000,
            description: '$18,000',
          },
          {
            value: 14000,
            description: '$19,000',
          },
          {
            value: 15000,
            description: '$20,000',
          },
          {
            value: 40000,
            description: '$Unlimited',
          },
        ],
        selectedExtraCover: null,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_STUFF,
      description:
        'For flights and accommodation worth more than $5,000, you can increase your coverage.',
      toUpdate: null,
      travellers: null,
      imageURL:
        'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/extra_cancellation.png',
    },
    {
      tripId: 'trip_1702430692324_29292dd9-9cde-47a0-a204-93ffab870d1f',
      boostId: 'boost_1702430692377_902b7d64-5e28-43c0-ad9c-532b864f7aad',
      userId: '07b2257d-4f70-4e2b-be26-9ad7a87fc0f5',
      code: 'GADGFREE',
      name: 'Gadget Cover',
      cmName: 'Gadget Cover (Freely)',
      benefits: [
        {
          name: 'Gadget Cover',
          description:
            'Increase the limit for all your laptops, phones or drones worth more than $750.',
        },
      ],
      price: '5000',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [
        {
          endDate: '2023-12-27',
          startDate: '2023-12-14',
        },
      ],
      duration: 14,
      boostProperty: {},
      isMandatory: false,
      template: null,
      isAdded: true,
      isSelected: true,
      category: BOOST_CATEGORY.MY_STUFF,
      description:
        'Increase the limit for all your laptops, phones or drones worth more than $750.',
      toUpdate: null,
      travellers: null,
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/gadget_cover.png',
      toggleStatus: null,
    },
    {
      tripId: 'trip_1702430692324_29292dd9-9cde-47a0-a204-93ffab870d1f',
      boostId: 'boost_1702430692375_39f60d96-2b53-42be-b20f-e4247c766115',
      userId: '07b2257d-4f70-4e2b-be26-9ad7a87fc0f5',
      code: 'LUGG',
      name: 'Specified Items',
      cmName: 'Increase Luggage Item Limits',
      benefits: [
        {
          name: 'Specified Items',
          description: 'Get extra cover for specific items worth more than $750.',
        },
      ],
      price: '1000',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [
        {
          endDate: '2023-12-27',
          startDate: '2023-12-14',
        },
      ],
      duration: 14,
      boostProperty: {
        coverAmountValues: [500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000],
        basePrice: 1000,
        specifiedItems: [],
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_STUFF,
      description: 'Get extra cover for specific items worth more than $750.',
      toUpdate: null,
      travellers: [
        {
          sortKey: '07b2257d-4f70-4e2b-be26-9ad7a87fc0f5',
          dob: '2000-12-12',
          isPrimary: true,
          isAdult: true,
          firstName: 'John',
          lastName: 'Doe',
          isDependant: false,
          isResident: true,
        },
      ],
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/specified_items.png',
    },
    {
      tripId: 'trip_1702430692324_29292dd9-9cde-47a0-a204-93ffab870d1f',
      boostId: 'boost_1702430692376_27e094f3-b3be-4cac-bd34-d119c01def36',
      userId: '07b2257d-4f70-4e2b-be26-9ad7a87fc0f5',
      code: 'SSPFREE',
      name: 'Snow Sports',
      cmName: 'Snow Sports + (Freely)',
      benefits: [
        {
          name: 'Snow Sports',
          description:
            'Going Off-Piste? This covers you for snow skiing, boarding, mobiling, heli-skiing and more.',
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [],
      duration: 0,
      boostProperty: {
        payPerDayRate: 1000,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_ACTIVITIES,
      description:
        'Going Off-Piste? This covers you for snow skiing, boarding, mobiling, heli-skiing and more.',
      toUpdate: null,
      travellers: null,
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/snow_activities.png',
    },
    {
      tripId: 'trip_1702430692324_29292dd9-9cde-47a0-a204-93ffab870d1f',
      boostId: 'boost_1702430692376_5bd5ff9a-b0c4-4308-afd2-b1ba7a2ec023',
      userId: '07b2257d-4f70-4e2b-be26-9ad7a87fc0f5',
      code: 'CRSF',
      name: 'Cruise Cover',
      cmName: 'Cruise (Freely)',
      benefits: [
        {
          name: 'Cruise Cover',
          description: 'Will you be travelling for two or more nights on a cruise?',
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [],
      duration: 0,
      boostProperty: {
        payPerDayRate: 800,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_ACTIVITIES,
      description: 'Will you be travelling for two or more nights on a cruise?',
      toUpdate: null,
      travellers: null,
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/cruise_cover.png',

      toggleStatus: BOOST_UI_STATUS.ADDING,
    },
    {
      tripId: 'trip_1702430692324_29292dd9-9cde-47a0-a204-93ffab870d1f',
      boostId: 'boost_1702430692376_0a8bff95-4b7f-4b2d-b4ad-5d052a543595',
      userId: '07b2257d-4f70-4e2b-be26-9ad7a87fc0f5',
      code: 'RCUF',
      name: 'Rental Vehicle Insurance Excess',
      cmName: 'Rental Vehicle Insurance Excess (Freely)',
      benefits: [
        {
          name: 'Rental Vehicle Insurance Excess',
          description: "If something goes wrong we'll pay the Car Rental Insurance Excess.",
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [],
      duration: 0,
      boostProperty: {
        payPerDayRate: 800,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_ACTIVITIES,
      description: "If something goes wrong we'll pay the Car Rental Insurance Excess.",
      toUpdate: null,
      travellers: null,
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/rental_ensurance.png',
    },
    {
      tripId: 'trip_1702430692324_29292dd9-9cde-47a0-a204-93ffab870d1f',
      boostId: 'boost_1702430692375_257e6a46-60b1-4133-9e44-875e4fa29bcb',
      userId: '07b2257d-4f70-4e2b-be26-9ad7a87fc0f5',
      code: 'ADVACT4',
      name: 'Adventure Activities',
      cmName: 'Adventure Activities (Freely)',
      benefits: [
        {
          name: 'Adventure Activities',
          description: 'Get your adrenaline rush on without breaking the bank.',
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [],
      duration: 0,
      boostProperty: {
        payPerDayRate: 700,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_ACTIVITIES,
      description: 'Get your adrenaline rush on without breaking the bank.',
      toUpdate: null,
      travellers: null,
      imageURL:
        'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/adventure_activities.png',
    },
    {
      tripId: 'trip_1702430692324_29292dd9-9cde-47a0-a204-93ffab870d1f',
      boostId: 'boost_1702430692376_99555f8a-25b2-497b-807e-ab06c059954f',
      userId: '07b2257d-4f70-4e2b-be26-9ad7a87fc0f5',
      code: 'MTCL4',
      name: 'Motorcycle Cover',
      cmName: 'Motorcycle + (Freely)',
      benefits: [
        {
          name: 'Motorcycle Cover',
          description:
            'For people wanting to ride a motorcycle, moped or scooter as a driver or passenger.',
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [],
      duration: 0,
      boostProperty: {
        payPerDayRate: 700,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_ACTIVITIES,
      description:
        'For people wanting to ride a motorcycle, moped or scooter as a driver or passenger.',
      toUpdate: null,
      travellers: null,
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/motobike_cover.png',
    },
  ],
  pdsLink: 'https://d3taykp79ux94z.cloudfront.net/public/au/pds/2023-08-30/pds.pdf',
  presignedCoiLink: null,
  pendingUpdates: null,
  policy: null,
  policyStatus: 'NORMAL',
  currentScreen: BOOST_CATEGORY.MY_HEALTH,
  promotionCode: {
    appLabel: 'default',
    productId: '457071cc-ebd5-421e-8997-aea860be4e86',
    discount: '0%',
    isFreeOfCharge: false,
    discountCode: 'F5B',
    reservedUntil: 10,
    productIds: [''],
  },

  metaData: {
    quoteId: 'n79uf502ba',
    partnerId: 'd3c45eb6-d413-4e11-8146-52adec6fe51c',
    excessAmount: 250,
  },
};

export const emcMockData: Trip = {
  sortKey: 'trip_1713742012317_9cb90802-d609-475f-8b82-0d61548ba7d3',
  primaryTravellerId: '5a581424-c5f0-c236-ba81-a1d9ba966df5',
  startDate: '2024-04-23',
  endDate: '2024-04-30',
  destinations: [
    {
      isCity: false,
      countryCode: 'CHN',
      countryFlagImage: 'https://d3taykp79ux94z.cloudfront.net/images/flags/cn.png',
      countryName: 'China',
      category: 'allDestinations',
      countryId: '121',
      longName: 'China',
      imageLinks: {
        mobile:
          'https://d3taykp79ux94z.cloudfront.net/images/destination-images/mobile/International_Default.jpg',
        desktop:
          'https://d3taykp79ux94z.cloudfront.net/images/destination-images/desktop/International_Default.jpg',
        tablet:
          'https://d3taykp79ux94z.cloudfront.net/images/destination-images/tablet/International_Default.jpg',
      },
      isTrending: true,
    },
  ],
  secondaryTravellers: [],
  state: TRIP_STATUS.NO_BOOST,
  tripType: TRIP_TYPE.INTERNATIONAL,
  price: 10700,
  isTripStarted: false,

  boosts: [
    {
      tripId: 'trip_1713742012317_9cb90802-d609-475f-8b82-0d61548ba7d3',
      boostId: 'boost_1713742012324_6f5330f2-4a8a-4086-b71c-24dcc32f2519',
      userId: '5a581424-c5f0-c236-ba81-a1d9ba966df5',
      code: 'OMD',
      name: 'Overseas Explorer',
      cmName: 'Oversea medical and dental',
      benefits: [
        {
          name: 'Overseas Explorer',
          description: 'Overseas Medical and Dental',
        },
      ],
      price: '5700',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [
        {
          endDate: '2024-04-30',
          startDate: '2024-04-23',
        },
      ],
      duration: 8,
      boostProperty: {},
      isMandatory: true,
      template: null,
      isAdded: true,
      isSelected: false,
      category: BOOST_CATEGORY.MY_HEALTH,
      description: 'Overseas Medical and Dental',
      toUpdate: null,
      travellers: null,
      imageURL: null,
    },
    {
      tripId: 'trip_1713742012317_9cb90802-d609-475f-8b82-0d61548ba7d3',
      boostId: 'boost_1713742012385_d662ad76-0a63-474d-b236-463255d32651',
      userId: '5a581424-c5f0-c236-ba81-a1d9ba966df5',
      code: 'CANX',
      name: 'Extra Cancellation',
      cmName: 'Cancellation Variation',
      benefits: [
        {
          name: 'Extra Cancellation',
          description:
            'For flights and accommodation worth more than $5,000, you can increase your coverage.',
        },
      ],
      price: '300',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [
        {
          endDate: '2024-04-30',
          startDate: '2024-04-23',
        },
      ],
      duration: 8,
      boostProperty: {
        coverAmountValues: [
          1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000, 13000, 14000,
          15000, 40000,
        ],
        options: [
          {
            value: 0,
            description: '$5,000',
          },
          {
            value: 1000,
            description: '$6,000',
          },
          {
            value: 2000,
            description: '$7,000',
          },
          {
            value: 3000,
            description: '$8,000',
          },
          {
            value: 4000,
            description: '$9,000',
          },
          {
            value: 5000,
            description: '$10,000',
          },
          {
            value: 6000,
            description: '$11,000',
          },
          {
            value: 7000,
            description: '$12,000',
          },
          {
            value: 8000,
            description: '$13,000',
          },
          {
            value: 9000,
            description: '$14,000',
          },
          {
            value: 10000,
            description: '$15,000',
          },
          {
            value: 11000,
            description: '$16,000',
          },
          {
            value: 12000,
            description: '$17,000',
          },
          {
            value: 13000,
            description: '$18,000',
          },
          {
            value: 14000,
            description: '$19,000',
          },
          {
            value: 15000,
            description: '$20,000',
          },
          {
            value: 40000,
            description: '$Unlimited',
          },
        ],
        selectedExtraCover: 1000,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: true,
      category: BOOST_CATEGORY.MY_STUFF,
      description:
        'For flights and accommodation worth more than $5,000, you can increase your coverage.',
      toUpdate: null,
      travellers: null,
      imageURL:
        'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/extra_cancellation.png',
    },
    {
      tripId: 'trip_1713742012317_9cb90802-d609-475f-8b82-0d61548ba7d3',
      boostId: 'boost_1713742012385_fed50698-3584-4619-8794-2ebdec5801a9',
      userId: '5a581424-c5f0-c236-ba81-a1d9ba966df5',
      code: 'GADGFREE',
      name: 'Gadget Cover',
      cmName: 'Gadget Cover (Freely)',
      benefits: [
        {
          name: 'Gadget Cover',
          description:
            'Increase the limit for all your laptops, phones or drones worth more than $750.',
        },
      ],
      price: '5000',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [
        {
          endDate: '2024-04-30',
          startDate: '2024-04-23',
        },
      ],
      duration: 8,
      boostProperty: {},
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_STUFF,
      description:
        'Increase the limit for all your laptops, phones or drones worth more than $750.',
      toUpdate: null,
      travellers: null,
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/gadget_cover.png',
    },
    {
      tripId: 'trip_1713742012317_9cb90802-d609-475f-8b82-0d61548ba7d3',
      boostId: 'boost_1713742012378_0a756b16-ce48-4a2a-86b7-4eef0d50dc0a',
      userId: '5a581424-c5f0-c236-ba81-a1d9ba966df5',
      code: 'LUGG',
      name: 'Specified Items',
      cmName: 'Increase Luggage Item Limits',
      benefits: [
        {
          name: 'Specified Items',
          description: 'Get extra cover for specific items worth more than $750.',
        },
      ],
      price: '1000',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [
        {
          endDate: '2024-04-30',
          startDate: '2024-04-23',
        },
      ],
      duration: 8,
      boostProperty: {
        coverAmountValues: [500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000],
        basePrice: 1000,
        specifiedItems: [
          {
            itemId: '19135989-2b3e-433c-850f-b168432a5ed1',
            travellerId: '5a581424-c5f0-c236-ba81-a1d9ba966df5',
            itemName: 'asdasd',
            selectedValue: 500,
            price: 1000,
          },
        ],
      },
      isMandatory: false,
      template: null,
      isAdded: true,
      isSelected: true,
      category: BOOST_CATEGORY.MY_STUFF,
      description: 'Get extra cover for specific items worth more than $750.',
      toUpdate: null,
      travellers: [
        {
          sortKey: '5a581424-c5f0-c236-ba81-a1d9ba966df5',
          dob: '2000-12-12',
          isPrimary: true,
          isAdult: true,
          firstName: '',
          lastName: '',
          isDependant: null,
          isResident: null,
        },
      ],
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/specified_items.png',
    },
    {
      tripId: 'trip_1713742012317_9cb90802-d609-475f-8b82-0d61548ba7d3',
      boostId: 'boost_1713742012384_5644eed1-1bc9-46d2-80e8-d9918026ed91',
      userId: '5a581424-c5f0-c236-ba81-a1d9ba966df5',
      code: 'SSPFREE',
      name: 'Snow Sports',
      cmName: 'Snow Sports + (Freely)',
      benefits: [
        {
          name: 'Snow Sports',
          description:
            'Going Off-Piste? This covers you for snow skiing, boarding, mobiling, heli-skiing and more.',
        },
      ],
      price: '2000',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [
        {
          endDate: '2024-04-25',
          startDate: '2024-04-24',
        },
      ],
      duration: 2,
      boostProperty: {
        payPerDayRate: 1000,
      },
      isMandatory: false,
      template: null,
      isAdded: true,
      isSelected: true,
      category: BOOST_CATEGORY.MY_ACTIVITIES,
      description:
        'Going Off-Piste? This covers you for snow skiing, boarding, mobiling, heli-skiing and more.',
      toUpdate: null,
      travellers: null,
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/snow_activities.png',
    },
    {
      tripId: 'trip_1713742012317_9cb90802-d609-475f-8b82-0d61548ba7d3',
      boostId: 'boost_1713742012384_4f4734f1-40fc-4a72-abf5-0d0ac64d3123',
      userId: '5a581424-c5f0-c236-ba81-a1d9ba966df5',
      code: 'CRSF',
      name: 'Cruise Cover',
      cmName: 'Cruise (Freely)',
      benefits: [
        {
          name: 'Cruise Cover',
          description: 'Will you be travelling for two or more nights on a cruise?',
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [],
      duration: 0,
      boostProperty: {
        payPerDayRate: 800,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_ACTIVITIES,
      description: 'Will you be travelling for two or more nights on a cruise?',
      toUpdate: null,
      travellers: null,
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/cruise_cover.png',
    },
    {
      tripId: 'trip_1713742012317_9cb90802-d609-475f-8b82-0d61548ba7d3',
      boostId: 'boost_1713742012384_050b5871-3a68-44c5-a87a-4bea464f71b5',
      userId: '5a581424-c5f0-c236-ba81-a1d9ba966df5',
      code: 'RCUF',
      name: 'Rental Vehicle Insurance Excess',
      cmName: 'Rental Vehicle Insurance Excess (Freely)',
      benefits: [
        {
          name: 'Rental Vehicle Insurance Excess',
          description: "If something goes wrong we'll pay the Car Rental Insurance Excess.",
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [],
      duration: 0,
      boostProperty: {
        payPerDayRate: 800,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_ACTIVITIES,
      description: "If something goes wrong we'll pay the Car Rental Insurance Excess.",
      toUpdate: null,
      travellers: null,
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/rental_ensurance.png',
    },
    {
      tripId: 'trip_1713742012317_9cb90802-d609-475f-8b82-0d61548ba7d3',
      boostId: 'boost_1713742012382_e2f68df6-6adc-4db0-bcc9-386c9f81edee',
      userId: '5a581424-c5f0-c236-ba81-a1d9ba966df5',
      code: 'ADVACT4',
      name: 'Adventure Activities',
      cmName: 'Adventure Activities (Freely)',
      benefits: [
        {
          name: 'Adventure Activities',
          description: 'Get your adrenaline rush on without breaking the bank.',
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [],
      duration: 0,
      boostProperty: {
        payPerDayRate: 700,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_ACTIVITIES,
      description: 'Get your adrenaline rush on without breaking the bank.',
      toUpdate: null,
      travellers: null,
      imageURL:
        'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/adventure_activities.png',
    },
    {
      tripId: 'trip_1713742012317_9cb90802-d609-475f-8b82-0d61548ba7d3',
      boostId: 'boost_1713742012383_0ed8e7dd-e3bb-40e6-9fb0-a996ddefbee3',
      userId: '5a581424-c5f0-c236-ba81-a1d9ba966df5',
      code: 'MTCL4',
      name: 'Motorcycle Cover',
      cmName: 'Motorcycle + (Freely)',
      benefits: [
        {
          name: 'Motorcycle Cover',
          description:
            'For people wanting to ride a motorcycle, moped or scooter as a driver or passenger.',
        },
      ],
      price: '0',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [],
      duration: 0,
      boostProperty: {
        payPerDayRate: 700,
      },
      isMandatory: false,
      template: null,
      isAdded: false,
      isSelected: false,
      category: BOOST_CATEGORY.MY_ACTIVITIES,
      description:
        'For people wanting to ride a motorcycle, moped or scooter as a driver or passenger.',
      toUpdate: null,
      travellers: null,
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/motobike_cover.png',
    },
    {
      tripId: 'trip_1713742012317_9cb90802-d609-475f-8b82-0d61548ba7d3',
      boostId: 'boost_1713742012386_ba852285-3d02-47c7-999a-8094af06d24e',
      userId: '5a581424-c5f0-c236-ba81-a1d9ba966df5',
      code: 'EMC',
      name: 'Existing Medical Condition',
      cmName: 'Existing Medical Condition',
      benefits: [
        {
          name: 'Existing Medical Condition',
          description: 'Existing Medical Condition',
        },
      ],
      price: '2000',
      currency: 'AUD',
      version: '2023-05-03',
      startEndDates: [
        {
          endDate: '2024-04-30',
          startDate: '2024-04-23',
        },
      ],
      duration: 8,
      boostProperty: {
        emcData: [
          {
            firstName: 'Asdf',
            isAdded: true,
            isSelected: true,
            lastName: 'Asgggasga',
            price: '2900',
            isCovered: true,
            assessmentNumber: '123456',
            medicalConditions: [
              {
                name: 'Asbestosis',
                isCovered: true,
              },
            ],
            screeningResult: [
              {
                CalculationType: '1',
                Language: 'en',
                Result:
                  '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',
              },
              {
                CalculationType: '2',
                Language: 'en',
                Result:
                  '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',
              },
            ],
            travellerId: '5a581424-c5f0-c236-ba81-a1d9ba966df5',
          },
          {
            firstName: 'GGG',
            isAdded: true,
            isSelected: true,
            lastName: 'QQQQQ',
            price: '5000',
            isCovered: true,
            assessmentNumber: '78901232',
            medicalConditions: [
              {
                name: 'Diabetes',
                isCovered: true,
              },
              {
                name: 'Broken Arm',
                isCovered: true,
              },
              {
                name: 'Asbestosis',
                isCovered: false,
              },
              {
                name: 'Hypertension',
                isCovered: false,
              },
            ],
            screeningResult: [
              {
                CalculationType: '1',
                Language: 'en',
                Result:
                  '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',
              },
              {
                CalculationType: '2',
                Language: 'en',
                Result:
                  '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',
              },
            ],
            travellerId: 'a02356ea-7306-4a83-bf7a-f0a6b85623c2',
          },
          {
            firstName: 'Sam',
            isAdded: true,
            isSelected: true,
            lastName: 'Smith',
            price: '2900',
            isCovered: false,
            assessmentNumber: '123423',
            medicalConditions: [
              {
                name: 'Asbestosis',
                isCovered: false,
              },
            ],
            screeningResult: [
              {
                CalculationType: '1',
                Language: 'en',
                Result:
                  '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',
              },
              {
                CalculationType: '2',
                Language: 'en',
                Result:
                  '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',
              },
            ],
            travellerId: '6a581424-c5f0-c236-ba81-a1d9ba966df6',
          },
          {
            firstName: 'MultiConditions',
            isAdded: true,
            isSelected: true,
            lastName: 'Smith',
            price: '2900',
            isCovered: false,
            assessmentNumber: '123423',
            medicalConditions: [
              {
                name: 'Acne',
                isCovered: true,
              },
              {
                name: 'Broken Arm',
                isCovered: true,
              },
              {
                name: 'Cancer',
                isCovered: true,
              },
              {
                name: ' Bipolar Disorder',
                isCovered: true,
              },
              {
                name: 'Asbestosis',
                isCovered: true,
              },
              {
                name: 'Cardiomiopathy',
                isCovered: true,
              },
              {
                name: 'Acromegaly',
                isCovered: true,
              },
              {
                name: 'Cardiomiopathy',
                isCovered: false,
              },
              {
                name: 'Acromegaly',
                isCovered: false,
              },
              {
                name: 'High blood pressure',
                isCovered: false,
              },
              {
                name: 'Asbestosis',
                isCovered: false,
              },
              {
                name: 'Cardiomiopathy',
                isCovered: false,
              },
              {
                name: 'Acromegaly',
                isCovered: false,
              },
              {
                name: 'High blood pressure',
                isCovered: false,
              },
              {
                name: 'Asbestosis',
                isCovered: false,
              },
            ],
            screeningResult: [
              {
                CalculationType: '1',
                Language: 'en',
                Result:
                  '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',
              },
              {
                CalculationType: '2',
                Language: 'en',
                Result:
                  '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',
              },
            ],
            travellerId: '6a581424-c5f0-c236-ba81-34343sdf',
          },
        ],
      },
      isMandatory: false,
      template: null,
      isAdded: true,
      isSelected: false,
      category: BOOST_CATEGORY.MY_EMC,
      description: 'Existing Medical Condition',
      toUpdate: null,
      travellers: [
        {
          sortKey: '5a581424-c5f0-c236-ba81-a1d9ba966df5',
          dob: '2000-12-12',
          isPrimary: true,
          isAdult: true,
          firstName: '',
          lastName: '',
          isDependant: null,
          isResident: null,
        },
        {
          sortKey: 'a02356ea-7306-4a83-bf7a-f0a6b85623c2',
          dob: '2000-12-12',
          isPrimary: true,
          isAdult: true,
          firstName: '',
          lastName: '',
          isDependant: null,
          isResident: null,
        },
        {
          sortKey: '6a581424-c5f0-c236-ba81-a1d9ba966df6',
          dob: '2000-12-12',
          isPrimary: true,
          isAdult: true,
          firstName: '',
          lastName: '',
          isDependant: null,
          isResident: null,
        },
        {
          sortKey: '6a581424-c5f0-c236-ba81-34343sdf',
          dob: '2000-12-12',
          isPrimary: true,
          isAdult: true,
          firstName: '',
          lastName: '',
          isDependant: null,
          isResident: null,
        },
      ],
      imageURL: 'https://d3taykp79ux94z.cloudfront.net/public/au/boost-images/undefined.png',
    },
  ],
  pdsLink: 'https://d3taykp79ux94z.cloudfront.net/public/au/pds/2023-08-30/pds.pdf',
  presignedCoiLink: null,
  pendingUpdates: null,
  policy: null,
  policyStatus: 'NORMAL',
  currentScreen: BOOST_CATEGORY.MY_HEALTH,
  primaryTraveller: {
    firstName: '',
    lastName: '',
    dob: '2000-12-12',
    isResident: true,
  },
  promotionCode: {
    appLabel: 'default',
    discountCode: null,
    productIds: ['457071cc-ebd5-421e-8997-aea860be4e86'],
    productId: '457071cc-ebd5-421e-8997-aea860be4e86',
    discount: '0%',
    reservedUntil: 1,
    isFreeOfCharge: false,
  },
  hasAddedBoosts: false,
  productId: '1',
  metaData: {
    quoteId: '02plm56ac2',
    partnerId: 'd3c45eb6-d413-4e11-8146-52adec6fe51c',
    excessAmount: 250,
  },
  createTs: 1713742012317,
  updatedAt: 1713742012317,
};
